import { HttpClient } from '../http-client';
import { msalInstance } from "../msalConfig";
import appconfig from "./appconfig.js";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

//import router from '../router';

export const userService = {
   login,
   logout,
   parseJwt,
   tokenData,
   isAuthorized,
   getDefaultUser,
   checkPassword,
   sendRestorePasswordAndExit,
   sendPasswordRestoreToken,
   loginWithEntraId,
   getValidToken,
   tokenValid,
   getInactivityRemainingTime,
};

function login(username, password) {
   HttpClient.post(
      'Identy/login',
      JSON.stringify({
         UserName: username,
         Password: password,
      })
   )
      .then(res => {
         localStorage.setItem('token', res.data.token);
         localStorage.setItem('tokenExpires', res.data.tokenExpires);

         // setTimeout(function() {
         //    location.href = `${process.env.VUE_APP_BASE_URL}`;
         //    //router.push('/');
         // }, 1000);
      })
      .catch(ex => {
         console.log(ex);
         console.log('auth failed');
      });
}

function logout() {
   localStorage.removeItem('token');
   localStorage.removeItem('tokenExpires');
}

function parseJwt(token) {
   try {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(
         atob(base64)
            .split('')
            .map(function (c) {
               return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
      );

      return JSON.parse(jsonPayload);
   }
   catch (error) {
      console.error("Error parsing JWT:", error);
      return undefined;
   }
}
function tokenData() {
   const token = localStorage.getItem('token');
   const tokenData = userService.parseJwt(token);
   return tokenData;
}

function isAuthorized() {
   const dateNow = Date.now();
   const tokenExpires = Date.parse(localStorage.getItem('tokenExpires'));
   const isTokenExpired = tokenExpires < dateNow;
   const loggedIn = localStorage.getItem('token');
   return loggedIn && !isTokenExpired;
}

function getDefaultUser() {
   return {
      id: null,
      realName: '',
      email: '',
      userName: '',
      password: '',
      active: true,
      isConfirmed: false,
      roles: 0,
      lockoutEnabled: true,
      passwordExpires: null,
   };
}
function checkPassword(inputtxt) {
   var paswd = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
   if (inputtxt.match(paswd)) {
      return true;
   } else {
      return false;
   }
}
function sendRestorePasswordAndExit(username, email) {
   HttpClient.post(`account/ResetPasswordLinkRequest`, {
      username: username,
      email: email,
   }
   )
}
function sendPasswordRestoreToken(token) {
   HttpClient.post(`account/ResetPassword?token=${token}`, {
      token: token,
   })
}

async function loginWithEntraId() {
   const loginRequest = {
      scopes: ["openid", "profile", "email", appconfig.entraid_api_permission],
      redirectUri: appconfig.entraid_redirectUri,
   };
   // console.log("Logging in with Entra ID...", loginRequest);
   await msalInstance.loginRedirect(loginRequest);
}


function tokenValid() {
   const today = new Date();
   const tokenExpiresDate = new Date(localStorage.getItem('tokenExpires'));
   // console.log("Token expires on:", tokenExpiresDate);
   // console.log("Today's date:", today);
   // console.log("Is token valid?", tokenExpiresDate > today);
   return tokenExpiresDate > today;
}

async function getValidToken() {
   // console.log('getValidToken called');
   let token = localStorage.getItem('token');
   if (!token) {
      return 'NoAuth';
   }

   const jwtPayload = parseJwt(token);
   if (jwtPayload && jwtPayload.iss && jwtPayload.iss.includes('windows.net')) {
      if (tokenValid()) {
         // console.log('Token is valid, returning existing token');
         return 'Bearer ' + token;
      } else {
         if (getInactivityRemainingTime() > 0) {
            // console.log('Token is expired, acquiring new token');
            const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
            if (!account) throw new Error('No active account');
            const loginRequest = {
               scopes: ['openid', 'profile', 'email', appconfig.entraid_api_permission],
               account: account,
            };

            try {
               console.log('Acquiring token silently...');
               const response = await msalInstance.acquireTokenSilent(loginRequest);
               // console.log("New token acquired:", response.accessToken);
               localStorage.setItem('token', response.accessToken);
               localStorage.setItem('tokenExpires', new Date(response.expiresOn).toISOString());
               return 'Bearer ' + response.accessToken;
            } catch (error) {
               if (error instanceof InteractionRequiredAuthError) {
                  console.error('Interaction required, redirecting to login...');
                  await msalInstance.loginRedirect(loginRequest);
               } else {
                  throw error;
               }
            }
         }
      }
   }

   return 'Bearer ' + token;
}

const INACTIVITY_LIMIT = (appconfig.inactivityLimitMinutes || 1) * 60 * 1000;
function getInactivityRemainingTime() {
   const now = Date.now();
   const lastActivity = localStorage.getItem('rx_lastActivity');
   const elapsed = now - parseInt(lastActivity);
   const remaining = INACTIVITY_LIMIT - elapsed;
   return remaining > 0 ? remaining : 0;
}